import { ExamTypePicker } from "src/components/NewComponents/Creator/ContentPicker/ExamTypePicker";
import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

export function ExamTypePickerContainer() {
	return (
		<LayoutWithSearch>
			<ExamTypePicker />
		</LayoutWithSearch>
	);
}
